import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PrintingTemplateFunctionArgument  {
    _originalTypeClassName = "zERP.BO.PrintingTemplateFunctionArgument";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PrintingTemplateFunctionArgument.translate = translateService;
}
this.Value = null;
this.PrintingTemplateFunctionArgumentKey = null;
this._key = this.PrintingTemplateFunctionArgumentKey = 0; 
}

static translate: TranslateService;
_key: any;
Value:any;
private _PrintingTemplateFunctionArgumentKey:any;
get PrintingTemplateFunctionArgumentKey(): any {
    return this._PrintingTemplateFunctionArgumentKey;
  }
set PrintingTemplateFunctionArgumentKey(value: any) {
    this._PrintingTemplateFunctionArgumentKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PrintingTemplateFunctionArgumentKey == null || $this.PrintingTemplateFunctionArgumentKey == 0;
            }


}